
/*
 * -------------------------------------------------------
 * THIS FILE WAS AUTOMATICALLY GENERATED (DO NOT MODIFY)
 * -------------------------------------------------------
 */

/* tslint:disable */
/* eslint-disable */

export enum DependentRelationship {
    child = "child",
    spouse = "spouse",
    familyMember = "familyMember",
    friend = "friend",
    other = "other",
    careProvider = "careProvider"
}

export enum AdminRenewActiveGymSearchCode {
    OK = "OK",
    NOT_RENEW_ACTIVE = "NOT_RENEW_ACTIVE",
    MEMBER_NOT_FOUND = "MEMBER_NOT_FOUND",
    INVALID_INPUT = "INVALID_INPUT"
}

export enum ServiceSectorKey {
    commercial = "commercial",
    government = "government"
}

export enum ServiceSectorName {
    Commercial = "Commercial",
    Government = "Government"
}

export enum RewardsPaymentSystem {
    UHC = "UHC",
    FitnessRewards = "FitnessRewards"
}

export enum promoDiscountType {
    percent = "percent",
    amount = "amount",
    none = "none"
}

export enum MemberStatus {
    "new" = "new",
    active = "active",
    exception = "exception",
    inactive = "inactive",
    deleting = "deleting",
    "for" = "for",
    debugging = "debugging",
    purposes = "purposes",
    ineligible = "ineligible",
    merged = "merged"
}

export enum SubscriptionStatus {
    valid = "valid",
    failed = "failed",
    failedRequestedChange = "failedRequestedChange",
    failedPendingChange = "failedPendingChange",
    failedPendingCancellation = "failedPendingCancellation",
    pendingChange = "pendingChange",
    pendingCancellation = "pendingCancellation",
    pendingChangeAndCancellation = "pendingChangeAndCancellation",
    pendingChangeAndIneligibility = "pendingChangeAndIneligibility",
    pendingIneligibility = "pendingIneligibility",
    pendingReactivation = "pendingReactivation",
    pendingReactivationAndChange = "pendingReactivationAndChange",
    propagatedPendingCancellation = "propagatedPendingCancellation",
    cancelled = "cancelled",
    cancelledByIneligibility = "cancelledByIneligibility",
    failedCancelled = "failedCancelled",
    requestedChange = "requestedChange",
    pendingSponsorChange = "pendingSponsorChange",
    notRequired = "notRequired"
}

export enum CreditCardType {
    none = "none",
    americanexpress = "americanexpress",
    amex = "amex",
    discover = "discover",
    mastercard = "mastercard",
    visa = "visa"
}

export enum MemberDataEventApplicationType {
    Web = "Web",
    Mobile = "Mobile"
}

export enum MemberDataEventType {
    LOGIN = "LOGIN",
    CONSENT = "CONSENT",
    CONSENT_LOCATION = "CONSENT_LOCATION",
    CONSENT_NOTIFY = "CONSENT_NOTIFY",
    CONSENT_FITNESS_DATA = "CONSENT_FITNESS_DATA",
    APP_INSTALL = "APP_INSTALL",
    APP_UNINSTALL = "APP_UNINSTALL",
    ONBOARD_CONVERSION = "ONBOARD_CONVERSION",
    FIRST_KEY_ACTIONS = "FIRST_KEY_ACTIONS",
    SEARCH = "SEARCH",
    APP_LAUNCH = "APP_LAUNCH",
    NATIVE_ONLINE_FITNESS_CONTENT_USAGE = "NATIVE_ONLINE_FITNESS_CONTENT_USAGE",
    GYM_SEARCH_RESULTS = "GYM_SEARCH_RESULTS",
    RATE_FACILITY = "RATE_FACILITY",
    INTERACTIONS = "INTERACTIONS",
    PERK_CLICK = "PERK_CLICK"
}

export enum MemberCheckStatus {
    matchFound = "matchFound",
    noMatch = "noMatch",
    ineligible = "ineligible",
    tooManyMatches = "tooManyMatches",
    internalServerError = "internalServerError"
}

export enum AuthStatus {
    unknown = "unknown",
    anonymous = "anonymous",
    authenticated = "authenticated",
    unauthenticated = "unauthenticated",
    unauthorized = "unauthorized",
    unverified = "unverified",
    qualified = "qualified"
}

export enum SurveyQuestionType {
    MultiSelect = "MultiSelect",
    SingleSelect = "SingleSelect"
}

export enum TierTypeTag {
    Primary = "Primary",
    Dependent = "Dependent"
}

export enum PortalIndicator {
    onepass = "onepass",
    onepassselect = "onepassselect",
    onepassuat = "onepassuat",
    onepassselectuat = "onepassselectuat"
}

export enum VodFavoriteType {
    workout = "workout",
    program = "program"
}

export enum ExclusionAction {
    ADD = "ADD",
    REMOVE = "REMOVE"
}

export enum PaymentType {
    apple_pay = "apple_pay",
    google_pay = "google_pay",
    credit_card = "credit_card"
}

export interface DependentBigNInput {
    firstName: string;
    lastName: string;
    dateOfBirth: string;
    email?: Nullable<string>;
    relationship: DependentRelationship;
}

export interface GeolocationInput {
    address?: Nullable<string>;
    city?: Nullable<string>;
    state?: Nullable<string>;
    zipcode?: Nullable<string>;
    latitude?: Nullable<number>;
    longitude?: Nullable<number>;
    distance?: Nullable<number>;
    minLatitude?: Nullable<number>;
    minLongitude?: Nullable<number>;
    maxLatitude?: Nullable<number>;
    maxLongitude?: Nullable<number>;
}

export interface SponsorClientNameAffiliationInput {
    rallyClientUniqueName: string;
    affiliation?: Nullable<string>;
    partner?: Nullable<string>;
}

export interface PreviewInput {
    token: string;
    tierId: string;
    rewardsDollarsApplied?: Nullable<number>;
    promoCodeConfiguration?: Nullable<PromoCodeConfiguration>;
}

export interface PromoCodeConfiguration {
    isEnrollmentFeeWaivedByPromo?: Nullable<boolean>;
    isTierDiscountPromoValid?: Nullable<boolean>;
    promoCodeApplied?: Nullable<string>;
    discountAmount?: Nullable<number>;
    discountType?: Nullable<string>;
}

export interface MemberDataEventInput {
    eventId: string;
    eventType: MemberDataEventType;
    context: MemberDataEventContext;
    payload?: Nullable<JsonObject>;
}

export interface MemberDataEventContext {
    applicationType: MemberDataEventApplicationType;
    deviceMake: string;
    deviceModel: string;
}

export interface MemberBigNInput {
    firstName?: Nullable<string>;
    lastName?: Nullable<string>;
    birthDate?: Nullable<string>;
    zipCode?: Nullable<string>;
    searchId?: Nullable<string>;
    groupId?: Nullable<string>;
}

export interface SurveyAnswer {
    questionId: string;
    response: string;
    memberId: string;
}

export interface SFCaseRequest {
    firstName: string;
    lastName: string;
    email: string;
    message: string;
    dateOfBirth: string;
    phone: string;
    memberCode?: Nullable<string>;
    confirmationCode?: Nullable<string>;
    programType?: Nullable<string>;
    rallyId?: Nullable<string>;
    eId?: Nullable<string>;
    hsId?: Nullable<string>;
    webAffiliation?: Nullable<string>;
    webClient?: Nullable<string>;
}

export interface CancellationReasonWithDetail {
    cancellationReasonId: string;
    details?: Nullable<string>;
}

export interface HsidEligibilityCheckRequest {
    additionalMemberInfo?: Nullable<HsidAdditionalMemberInfoInput>;
    dob?: Nullable<string>;
    portalIndicator: PortalIndicator;
    eligibilityInfo?: Nullable<Nullable<HsidEligibilityInfoInput>[]>;
    names?: Nullable<Nullable<HsidNameInput>[]>;
}

export interface HsidEligibilityInfoInput {
    identifiers?: Nullable<HsidEligibilityIdentifierInput>;
}

export interface HsidAdditionalMemberInfoInput {
    zip?: Nullable<string>;
    uuid?: Nullable<string>;
    eid?: Nullable<string>;
}

export interface HsidEligibilityIdentifierInput {
    memberId?: Nullable<string>;
}

export interface HsidNameInput {
    first?: Nullable<string>;
    last?: Nullable<string>;
}

export interface FacilityKeyInput {
    name: string;
    address: string;
    city: string;
    state: string;
    zipCode: string;
}

export interface AdvantageProfile {
    affiliation?: Nullable<string>;
    avatar?: Nullable<string>;
    client?: Nullable<string>;
    coins?: Nullable<number>;
    isImpersonator?: Nullable<boolean>;
    messageCount?: Nullable<number>;
    partner?: Nullable<string>;
    profileName?: Nullable<string>;
    rallyId?: Nullable<string>;
    sessionId?: Nullable<string>;
}

export interface AdvantageChrome {
    profile?: Nullable<AdvantageProfile>;
    config: string;
}

export interface KeyNamePair {
    key: string;
    name: string;
}

export interface TagDefinition {
    key: string;
    name: string;
    type: KeyNamePair;
    feature?: Nullable<KeyNamePair>;
}

export interface DashboardPromo {
    name?: Nullable<string>;
    imageUrl?: Nullable<string>;
    eyebrow?: Nullable<string>;
    header?: Nullable<string>;
    body?: Nullable<string>;
    ctaLabel?: Nullable<string>;
    ctaRouteKey?: Nullable<string>;
    website?: Nullable<string>;
    authTag?: Nullable<TagDefinition>;
    rank?: Nullable<number>;
    startDate?: Nullable<string>;
    endDate?: Nullable<string>;
    hipaaConsentRequired?: Nullable<boolean>;
    iconName?: Nullable<string>;
}

export interface DependentBigN {
    firstName: string;
    lastName: string;
    dateOfBirth: string;
    email?: Nullable<string>;
    relationship: DependentRelationship;
}

export interface DependentMemberInfo {
    primaryCode?: Nullable<string>;
    secondaryCodes?: Nullable<Nullable<string>[]>;
    effectiveTierId?: Nullable<string>;
    pendingTierId?: Nullable<string>;
    effectiveDate?: Nullable<string>;
    pendingDate?: Nullable<string>;
    cancellationDate?: Nullable<string>;
    terminationDate?: Nullable<string>;
    memberStatus?: Nullable<MemberStatus>;
    subscriptionStatus?: Nullable<SubscriptionStatus>;
    nextPaymentDate?: Nullable<string>;
}

export interface DependentWithDecrypted {
    dependentId: string;
    primaryId: string;
    dependentBigNInput?: Nullable<string>;
    bigN?: Nullable<DependentBigN>;
    memberInfo?: Nullable<DependentMemberInfo>;
    isDependentAnnualFeePaid?: Nullable<boolean>;
}

export interface Empty {
    _?: Nullable<boolean>;
}

export interface DependentInfo {
    canAddFamilyMember: boolean;
    paymentMethod?: Nullable<RecurlyPaymentInfo>;
}

export interface RecurlyPaymentInfo {
    object?: Nullable<string>;
    cardType?: Nullable<string>;
    firstSix?: Nullable<string>;
    lastFour?: Nullable<string>;
    lastTwo?: Nullable<string>;
    expMonth?: Nullable<number>;
    expYear?: Nullable<number>;
    gatewayToken?: Nullable<string>;
    gatewayCode?: Nullable<string>;
    billingAgreementId?: Nullable<string>;
    nameOnAccount?: Nullable<string>;
    accountType?: Nullable<string>;
    routingNumber?: Nullable<string>;
    routingNumberBank?: Nullable<string>;
}

export interface AssumedEligibleMemberBigNInput {
    firstName: string;
    lastName: string;
    dateOfBirth: string;
    email?: Nullable<string>;
}

export interface PromoCodeDateOverrides {
    startDate?: Nullable<string>;
    expirationDate?: Nullable<string>;
}

export interface PromoCodePerEnv {
    prod?: Nullable<PromoCodeDateOverrides>;
}

export interface PromoCode {
    name: string;
    startDate: string;
    expirationDate: string;
    sponsorId: string;
    maxRedemptions: number;
    tag: string;
    eligibleTier?: Nullable<string>;
    discountAmount?: Nullable<number>;
    discountType?: Nullable<string>;
    perEnv?: Nullable<PromoCodePerEnv>;
}

export interface CodesRedeemedOnAnAccount {
    codesRedeemedOnAnAccount?: Nullable<string>;
}

export interface DependentEdgeResponse {
    success: boolean;
    errorMessage?: Nullable<string>;
    dependentId?: Nullable<string>;
}

export interface EmailSupportResponse {
    success: boolean;
    errorMessage?: Nullable<string>;
}

export interface ValidationResponse {
    message: string;
}

export interface StateName {
    stateName: string;
    stateNameShort: string;
}

export interface County_Pass {
    countyName: string;
    fipsCode: string;
    state?: Nullable<StateName>;
}

export interface Geolocation {
    name?: Nullable<string>;
    address?: Nullable<string>;
    city?: Nullable<string>;
    state?: Nullable<string>;
    zipcode?: Nullable<string>;
    country?: Nullable<string>;
    counties?: Nullable<Nullable<County_Pass>[]>;
    latitude?: Nullable<number>;
    longitude?: Nullable<number>;
    distanceFromCoordinate?: Nullable<number>;
    placeId?: Nullable<string>;
}

export interface MemberLocation {
    summary?: Nullable<string>;
    latitude: number;
    longitude: number;
}

export interface UserAcceptanceAuth {
    termsOfServiceandPrivacyPolicy?: Nullable<string>;
    communication?: Nullable<string>;
    privacyPolicy?: Nullable<string>;
}

export interface UserAcceptance {
    authorizations?: Nullable<UserAcceptanceAuth>;
}

export interface EventLocationCluster {
    nameClusters?: Nullable<Nullable<EventNameCluster>[]>;
    locationClusterKey: string;
    location?: Nullable<Geolocation>;
    tierIds?: Nullable<Nullable<string>[]>;
    authTags?: Nullable<Nullable<TagDefinition>[]>;
    tileKey?: Nullable<string>;
}

export interface EventNameCluster {
    eventOfferings?: Nullable<Nullable<EventOffering_PassEdge>[]>;
    nameClusterKey: string;
    name: string;
    description?: Nullable<string>;
    website?: Nullable<string>;
    inPerson?: Nullable<boolean>;
    online: boolean;
    cardImageUrl?: Nullable<string>;
    mapImageUrl?: Nullable<string>;
    eventTags?: Nullable<Nullable<TagDefinition>[]>;
}

export interface AdminRenewActiveGymSearchResult {
    offerings: FacilityOffering[];
    code: AdminRenewActiveGymSearchCode;
    message?: Nullable<string>;
}

export interface OnlineFitnessOffering {
    id: string;
    vendorName?: Nullable<string>;
    vendorDescription?: Nullable<string>;
    vendorImage?: Nullable<string>;
    gymType?: Nullable<string>;
    numberOfClasses?: Nullable<number>;
    website?: Nullable<string>;
    product?: Nullable<string>;
    checkmarkOptions?: Nullable<Nullable<string>[]>;
    featuresToBeFilteredBy?: Nullable<Nullable<StaticOfferingFilter>[]>;
}

export interface EventOffering_PassEdge {
    eventId: string;
    eventKey?: Nullable<string>;
    dayTags?: Nullable<Nullable<TagDefinition>[]>;
    timeTags?: Nullable<Nullable<TagDefinition>[]>;
    startDate?: Nullable<string>;
    endDate?: Nullable<string>;
    startTime?: Nullable<string>;
    endTime?: Nullable<string>;
    timezone?: Nullable<string>;
    frequency?: Nullable<string>;
    startDateTimeISO?: Nullable<string>;
    endDateTimeISO?: Nullable<string>;
    nameClusterKey?: Nullable<string>;
    name: string;
    description?: Nullable<string>;
    website?: Nullable<string>;
    inPerson?: Nullable<boolean>;
    online: boolean;
    cardImageUrl?: Nullable<string>;
    mapImageUrl?: Nullable<string>;
    eventTags?: Nullable<Nullable<TagDefinition>[]>;
    locationClusterKey?: Nullable<string>;
    location?: Nullable<Geolocation>;
    tierIds?: Nullable<Nullable<string>[]>;
    authTags?: Nullable<Nullable<TagDefinition>[]>;
    tileKey?: Nullable<string>;
}

export interface DaysOfTheWeek {
    sunday: boolean;
    monday: boolean;
    tuesday: boolean;
    wednesday: boolean;
    thursday: boolean;
    friday: boolean;
    saturday: boolean;
}

export interface FacilityOffering {
    facilityId: string;
    name: string;
    description?: Nullable<string>;
    phoneNumber?: Nullable<string>;
    website?: Nullable<string>;
    note?: Nullable<string>;
    premium: boolean;
    location: Geolocation;
    tileKey?: Nullable<string>;
    imageUrl?: Nullable<string>;
    authTags?: Nullable<Nullable<TagDefinition>[]>;
    eventTags?: Nullable<Nullable<TagDefinition>[]>;
    facilityTags?: Nullable<Nullable<TagDefinition>[]>;
    tierIds?: Nullable<Nullable<string>[]>;
    startsAtTier?: Nullable<Tier_Pass>;
    status?: Nullable<boolean>;
    partnerId?: Nullable<string>;
    govtMarketedStatus?: Nullable<string>;
    govtRecruitmentStatus?: Nullable<string>;
    govtProduct?: Nullable<string>;
    govtNonMarketedReason?: Nullable<string>;
    brand?: Nullable<string>;
    commRecruitmentStatus?: Nullable<string>;
    commProduct?: Nullable<string>;
    commMarketedStatus?: Nullable<string>;
    commNonMarketedReason?: Nullable<string>;
    govtFamilyRecruitmentStatus?: Nullable<string>;
    govtFamilyMarketedStatus?: Nullable<string>;
    govtFamilyNonMarketedReason?: Nullable<string>;
    processingChannelChange?: Nullable<string>;
    changeEffectiveDate?: Nullable<string>;
    clubId?: Nullable<string>;
    billingNetworkCode?: Nullable<Nullable<string>[]>;
    commercialNote?: Nullable<string>;
    governmentNote?: Nullable<string>;
    clientNonMarketed?: Nullable<string>;
}

export interface StaticOffering_PassEdge {
    name?: Nullable<string>;
    imageUrl?: Nullable<string>;
    header?: Nullable<string>;
    body?: Nullable<string>;
    startDate?: Nullable<string>;
    subheader?: Nullable<string>;
    footer?: Nullable<string>;
    ctaText?: Nullable<string>;
    website?: Nullable<string>;
    callouts?: Nullable<Nullable<StaticOfferingCallout>[]>;
    authTag?: Nullable<TagDefinition>;
    feature?: Nullable<KeyNamePair>;
    tierIds?: Nullable<Nullable<string>[]>;
    hipaaConsentRequired?: Nullable<boolean>;
    featuresToBeFilteredBy?: Nullable<Nullable<StaticOfferingFilter>[]>;
    benefits?: Nullable<Nullable<string>[]>;
    prodWebsite?: Nullable<string>;
}

export interface StaticOfferingCallout {
    name?: Nullable<string>;
    imageUrl?: Nullable<string>;
    header?: Nullable<string>;
    body?: Nullable<string>;
    bullets?: Nullable<Nullable<string>[]>;
}

export interface StaticOfferingFilter {
    name?: Nullable<string>;
}

export interface PaymentDetail {
    paymentMonth: string;
    paymentAmount: number;
}

export interface Tier_Pass {
    tierId: string;
    tierGroupId: string;
    name: string;
    benefits?: Nullable<Nullable<string>[]>;
    popularBrands?: Nullable<Nullable<string>[]>;
    imageUrl?: Nullable<string>;
    enrollmentFee: number;
    monthlyFee: number;
    paymentRequired: boolean;
    features?: Nullable<Nullable<KeyNamePair>[]>;
    authTags?: Nullable<Nullable<TagDefinition>[]>;
    initialPaymentDetails: Nullable<PaymentDetail>[];
    initialPaymentAmount: number;
    tierTypeTags?: Nullable<Nullable<TierTypeTag>[]>;
}

export interface ServiceSector {
    key: ServiceSectorKey;
    name: string;
}

export interface BenefitSummary {
    header: string;
    body: string;
}

export interface TierGroup {
    tierGroupId: string;
    name: string;
    serviceSector: ServiceSector;
    benefitSummaries?: Nullable<Nullable<BenefitSummary>[]>;
    tiers?: Nullable<Nullable<Tier_Pass>[]>;
}

export interface TierCategory {
    id: string;
    name?: Nullable<string>;
    imageFilename?: Nullable<string>;
    benefits?: Nullable<Nullable<string>[]>;
    popularBrands?: Nullable<Nullable<string>[]>;
}

export interface SponsorClientNameAffiliation {
    rallyClientUniqueName: string;
    affiliation?: Nullable<string>;
    partner?: Nullable<string>;
    phoneNumber?: Nullable<string>;
}

export interface Sponsor {
    sponsorId: string;
    product?: Nullable<string>;
    clientNameAffiliations?: Nullable<Nullable<SponsorClientNameAffiliation>[]>;
    serviceSector: ServiceSector;
    tierGroup: TierGroup;
    defaultTier?: Nullable<Tier_Pass>;
    rewardsPaymentSystem?: Nullable<string>;
    paymentRequired: boolean;
    hipaaConsentRequired: boolean;
    hasRewards: boolean;
    chargeDependentEnrollmentFee: boolean;
    isCancelAnnually: boolean;
    isDependentMinAge16: boolean;
    clientLogoUrl: string;
    chargeEnrollmentFeeOnTierChange: boolean;
}

export interface SponsorSearchSuggestion {
    vanityName: string;
    sponsorId: string;
    isAssumedEligibleSponsor: boolean;
}

export interface MemberCode {
    code: string;
    generationMethod: string;
    generationDate: string;
}

export interface RecurlyResponse {
    object: string;
}

export interface TaxInfo {
    type?: Nullable<string>;
    region?: Nullable<string>;
    rate?: Nullable<number>;
}

export interface PreviewInfo {
    subtotal?: Nullable<string>;
    tax?: Nullable<string>;
    taxInfo?: Nullable<TaxInfo>;
    total?: Nullable<string>;
    calculatedTotal?: Nullable<string>;
    taxAmount?: Nullable<string>;
    rewardsDollars?: Nullable<string>;
    totalCreditApplied?: Nullable<string>;
    balanceDue?: Nullable<string>;
}

export interface SubscriptionInfo {
    hasRecurlyAccount?: Nullable<boolean>;
    creditCardType?: Nullable<CreditCardType>;
    creditCardHint?: Nullable<string>;
    finalPaymentDate?: Nullable<string>;
    nextPaymentDate?: Nullable<string>;
    paymentAmount: number;
    paymentType?: Nullable<string>;
    finalAccessDate?: Nullable<string>;
    requestedChangeDate?: Nullable<string>;
    requestedChangeTier?: Nullable<Tier_Pass>;
}

export interface MemberAnnualFee {
    passMemberId: string;
    status: string;
    createdAt: string;
    updatedAt: string;
}

export interface Member_Pass {
    memberId: string;
    sponsorId: string;
    rallyId?: Nullable<string>;
    eid?: Nullable<string>;
    hsId?: Nullable<string>;
    isImpersonated: boolean;
    exceptionId?: Nullable<string>;
    memberStatus: MemberStatus;
    firstName: string;
    lastName: string;
    birthDate: string;
    startDate: string;
    primaryCode?: Nullable<MemberCode>;
    secondaryCodes?: Nullable<Nullable<MemberCode>[]>;
    effectiveTier?: Nullable<Tier_Pass>;
    effectiveDate?: Nullable<string>;
    pendingTier?: Nullable<Tier_Pass>;
    pendingDate?: Nullable<string>;
    subscriptionStatus: SubscriptionStatus;
    subscriptionInfo?: Nullable<SubscriptionInfo>;
    lastLocation?: Nullable<MemberLocation>;
    hipaaConsentAt?: Nullable<string>;
    lastViewedFtueAt?: Nullable<string>;
    lineOfBusiness?: Nullable<string>;
    suspendEnrollmentFee?: Nullable<boolean>;
    appleWalletPassUrl?: Nullable<string>;
    googleWalletPassUrl?: Nullable<string>;
    invoices?: Nullable<PageOfInvoices>;
    invoicePdf?: Nullable<string>;
    primaryFamilyMemberCode?: Nullable<string>;
    isPrimaryMemberAnnualFeePaid?: Nullable<boolean>;
}

export interface Invoice {
    id: string;
    number: string;
    billDate: string;
    price: number;
    currency?: Nullable<string>;
    state?: Nullable<string>;
    description?: Nullable<string>;
}

export interface PageOfInvoices {
    data: Nullable<Invoice>[];
    hasMore: boolean;
    cursor?: Nullable<string>;
}

export interface MemberCodeSearchResult {
    internalMember?: Nullable<Member_Pass>;
    externalMember?: Nullable<ExternalMember>;
}

export interface ExternalMember {
    firstName?: Nullable<string>;
    lastName?: Nullable<string>;
    memberCode?: Nullable<string>;
    serviceSector?: Nullable<string>;
    memberStatus?: Nullable<string>;
    tierName?: Nullable<string>;
    memberStartDate?: Nullable<string>;
    memberEndDate?: Nullable<string>;
}

export interface InternalMember {
    id?: Nullable<string>;
    rallyId?: Nullable<string>;
    passSponsorId?: Nullable<string>;
    rallyClientId?: Nullable<string>;
    memberStatus?: Nullable<MemberStatus>;
}

export interface MemberCheck {
    firstName?: Nullable<string>;
    lastName?: Nullable<string>;
    code?: Nullable<string>;
    explanation?: Nullable<string>;
    sector?: Nullable<string>;
    status: MemberCheckStatus;
    tierName?: Nullable<string>;
    tags?: Nullable<Nullable<string>[]>;
    memberStartDate?: Nullable<string>;
    memberEndDate?: Nullable<string>;
    eid?: Nullable<string>;
    product?: Nullable<string>;
    sponsorId?: Nullable<string>;
    isDependent?: Nullable<boolean>;
    tierGroupId?: Nullable<string>;
}

export interface MemberEligibilityCheck {
    firstName?: Nullable<string>;
    lastName?: Nullable<string>;
    status: MemberCheckStatus;
    registrationUrl?: Nullable<string>;
    serviceSector?: Nullable<string>;
    memberCode?: Nullable<string>;
}

export interface MemberBigNInputWithPortalIndicator {
    firstName?: Nullable<string>;
    lastName?: Nullable<string>;
    birthDate?: Nullable<string>;
    zipCode?: Nullable<string>;
    searchId?: Nullable<string>;
    groupId?: Nullable<string>;
    portalIndicator: PortalIndicator;
}

export interface CurrentState {
    isActive: boolean;
    isRenewActive: boolean;
    authStatus: AuthStatus;
    authRallyId?: Nullable<string>;
    isHsidSessionValid: boolean;
    isFromAikyamPortal?: Nullable<boolean>;
    authHsid?: Nullable<string>;
    currentMemberId?: Nullable<string>;
    currentSponsorId?: Nullable<string>;
    currentTierId?: Nullable<string>;
    currentTierGroupId?: Nullable<string>;
    impersonationId?: Nullable<string>;
    secondsUntilIdle?: Nullable<number>;
    canAddFamilyMember?: Nullable<boolean>;
    idToken?: Nullable<string>;
    isImpersonatedView?: Nullable<boolean>;
}

export interface Survey {
    id: string;
    description: string;
}

export interface SurveyQuestion {
    id: string;
    surveyId: string;
    description: string;
    questionType?: Nullable<SurveyQuestionType>;
}

export interface SurveyQuestionOption {
    id: string;
    surveyQuestionId: string;
    optionType: string;
    description: string;
}

export interface CancellationReason {
    id?: Nullable<string>;
    description?: Nullable<string>;
}

export interface Balance {
    amount?: Nullable<number>;
    error?: Nullable<string>;
}

export interface RewardsDollarAmount {
    onePassCredit?: Nullable<Balance>;
    rewardsBalance?: Nullable<Balance>;
}

export interface AvailableOnePassCredit {
    credit?: Nullable<Balance>;
}

export interface HsidSession {
    isHsidSessionValid: boolean;
    isFromAikyamPortal?: Nullable<boolean>;
    idToken?: Nullable<string>;
}

export interface OhidSession {
    isOhidSessionValid: boolean;
    clientName?: Nullable<string>;
    clientEmail?: Nullable<string>;
}

export interface HsidEligibilityCheckResponse {
    eligibilityStatus?: Nullable<string>;
    eligibilityFailureCode?: Nullable<string>;
    eligibilityFailureMessage?: Nullable<string>;
    eligibilityData?: Nullable<HsidEligiblityData>;
}

export interface HsidEligiblityData {
    eligibilityKey?: Nullable<string>;
    dob?: Nullable<string>;
    portalIndicator: PortalIndicator;
    zip?: Nullable<string>;
    eligibilityInfo?: Nullable<Nullable<HsidEligibilityInfo>[]>;
}

export interface HsidEligibilityInfo {
    identifiers?: Nullable<HsidEligibilityIdentifier>;
    names?: Nullable<HsidName>;
}

export interface HsidName {
    first?: Nullable<string>;
    last?: Nullable<string>;
}

export interface HsidEligibilityIdentifier {
    memberId?: Nullable<string>;
    individualId?: Nullable<string>;
    accountId?: Nullable<string>;
    businessType?: Nullable<string>;
    groupNumber?: Nullable<string>;
    planCategory?: Nullable<string>;
    memberType?: Nullable<string>;
    coverageStartDate?: Nullable<string>;
    coverageEndDate?: Nullable<string>;
    planName?: Nullable<string>;
    portalIndicator?: Nullable<string>;
    encryptedUserName?: Nullable<string>;
    mbi?: Nullable<string>;
    planStatus?: Nullable<string>;
    insuredPlanId?: Nullable<string>;
    pbp_Number?: Nullable<string>;
    segmentId?: Nullable<string>;
    cms_Contract_Num?: Nullable<string>;
    ucardEligible?: Nullable<boolean>;
    employerGroupIndicator?: Nullable<boolean>;
    applicationId?: Nullable<string>;
    receivedDate?: Nullable<string>;
}

export interface DebitRewards {
    success?: Nullable<boolean>;
    error?: Nullable<string>;
}

export interface TrustedToken {
    token?: Nullable<string>;
}

export interface HsidAuthnTokenResponse {
    access_token?: Nullable<string>;
    refresh_token?: Nullable<string>;
    id_token?: Nullable<string>;
    token_type?: Nullable<string>;
    expires_in?: Nullable<number>;
}

export interface HsidSessionInfo {
    access_token?: Nullable<string>;
    refresh_token?: Nullable<string>;
    id_token?: Nullable<string>;
    token_type?: Nullable<string>;
    expires_in_seconds?: Nullable<string>;
    expires_at?: Nullable<string>;
    hsid?: Nullable<string>;
    encryptedUnverifiedMemberBigN?: Nullable<string>;
    memberId?: Nullable<string>;
    sponsorId?: Nullable<string>;
    tierId?: Nullable<string>;
    sensitiveData?: Nullable<string>;
    isUnverifiedUser?: Nullable<boolean>;
}

export interface HsidMatchedSessionFields {
    authnTokenResponse: HsidAuthnTokenResponse;
    expires_at: DateTime;
    hsid: string;
    memberLookupResponse?: Nullable<HsidMemberLookupResponse>;
}

export interface UnverifiedMemberBigN {
    firstName: string;
    lastName: string;
    dateOfBirth: string;
    searchId?: Nullable<string>;
    email: string;
}

export interface UnverifiedMemberStepUpFields {
    firstName: string;
    lastName: string;
    dateOfBirth: string;
    searchId: string;
    hsid: string;
}

export interface HsidUnmatchedSessionFields {
    authnTokenResponse: HsidAuthnTokenResponse;
    expires_at: DateTime;
    hsid: string;
    unverifiedMemberBigN: UnverifiedMemberBigN;
}

export interface HsidDecodedJwtToken {
    sub?: Nullable<string>;
    SessionStateID?: Nullable<string>;
    birthdate?: Nullable<string>;
    email_verified?: Nullable<boolean>;
    amr?: Nullable<Nullable<string>[]>;
    iss?: Nullable<string>;
    auth_flow?: Nullable<string>;
    preferred_username?: Nullable<string>;
    given_name?: Nullable<string>;
    locale?: Nullable<string>;
    sid?: Nullable<string>;
    aud?: Nullable<string>;
    acr?: Nullable<string>;
    azp?: Nullable<string>;
    auth_time?: Nullable<number>;
    name?: Nullable<string>;
    nickname?: Nullable<string>;
    exp?: Nullable<number>;
    family_name?: Nullable<string>;
    iat?: Nullable<number>;
    email?: Nullable<string>;
    jti?: Nullable<string>;
}

export interface HsidMemberLookupResponse {
    memberId?: Nullable<string>;
    sponsorId?: Nullable<string>;
    tierId?: Nullable<string>;
    sensitiveData?: Nullable<string>;
    isGovernmentUser?: Nullable<boolean>;
}

export interface VodStream {
    url: string;
    drm: string;
    expiresAt?: Nullable<string>;
}

export interface VodVideo {
    id: string;
    provider: string;
    providerVideoId: string;
    title: string;
    description?: Nullable<string>;
    durationSeconds: number;
    instructor?: Nullable<string>;
    level?: Nullable<string>;
    categories: string[];
    equipment: string[];
    programName?: Nullable<string>;
    language: string;
    publishedAt: string;
    updatedAt: string;
    thumbnailUrl?: Nullable<string>;
    streams?: Nullable<VodStream[]>;
}

export interface VodVideoList {
    items: VodVideo[];
    cursor?: Nullable<string>;
}

export interface VodCategory {
    id?: Nullable<string>;
    slug: string;
    name: string;
    description?: Nullable<string>;
    videoCount: number;
    thumbnailUrl?: Nullable<string>;
    logoUrl?: Nullable<string>;
}

export interface VodFavorite {
    favoriteType: VodFavoriteType;
    targetId: string;
    createdAt: string;
}

export interface VodFavoriteMutationResult {
    success: boolean;
}

export interface IQuery {
    allServiceSectors(): Nullable<Nullable<ServiceSector>[]> | Promise<Nullable<Nullable<ServiceSector>[]>>;
    allFeatures(): Nullable<Nullable<KeyNamePair>[]> | Promise<Nullable<Nullable<KeyNamePair>[]>>;
    allTags(): Nullable<Nullable<TagDefinition>[]> | Promise<Nullable<Nullable<TagDefinition>[]>>;
    allAuthTags(): Nullable<Nullable<TagDefinition>[]> | Promise<Nullable<Nullable<TagDefinition>[]>>;
    allEventTags(): Nullable<Nullable<TagDefinition>[]> | Promise<Nullable<Nullable<TagDefinition>[]>>;
    allFacilityTags(): Nullable<Nullable<TagDefinition>[]> | Promise<Nullable<Nullable<TagDefinition>[]>>;
    currentMember(): Nullable<Member_Pass> | Promise<Nullable<Member_Pass>>;
    currentState(): CurrentState | Promise<CurrentState>;
    currentSponsor(): Nullable<Sponsor> | Promise<Nullable<Sponsor>>;
    getSearchSuggestions(searchInput: string, limit?: Nullable<number>): SponsorSearchSuggestion[] | Promise<SponsorSearchSuggestion[]>;
    currentTierGroup(): Nullable<TierGroup> | Promise<Nullable<TierGroup>>;
    currentTier(): Nullable<Tier_Pass> | Promise<Nullable<Tier_Pass>>;
    cancellationReasons(): Nullable<Nullable<CancellationReason>[]> | Promise<Nullable<Nullable<CancellationReason>[]>>;
    allSurveys(): Nullable<Nullable<Survey>[]> | Promise<Nullable<Nullable<Survey>[]>>;
    surveyQuestions(surveyId?: Nullable<string>): Nullable<Nullable<SurveyQuestion>[]> | Promise<Nullable<Nullable<SurveyQuestion>[]>>;
    surveyQuestionOptions(questionId?: Nullable<string>): Nullable<Nullable<SurveyQuestionOption>[]> | Promise<Nullable<Nullable<SurveyQuestionOption>[]>>;
    availableTiers(): Nullable<Nullable<Tier_Pass>[]> | Promise<Nullable<Nullable<Tier_Pass>[]>>;
    dashboardPromos(): Nullable<Nullable<DashboardPromo>[]> | Promise<Nullable<Nullable<DashboardPromo>[]>>;
    getListOfDependents(): Nullable<Nullable<DependentWithDecrypted>[]> | Promise<Nullable<Nullable<DependentWithDecrypted>[]>>;
    getDependentInfo(): Nullable<DependentInfo> | Promise<Nullable<DependentInfo>>;
    getDependentById(dependentId?: Nullable<string>): Nullable<DependentWithDecrypted> | Promise<Nullable<DependentWithDecrypted>>;
    eventOfferings(location: GeolocationInput, tierGroupScope?: Nullable<boolean>, offset?: Nullable<number>, limit?: Nullable<number>, startDate?: Nullable<string>, endDate?: Nullable<string>, sortBy?: Nullable<string>, knownTileKeys?: Nullable<Nullable<string>[]>, todayDate?: Nullable<string>): Nullable<Nullable<EventOffering_PassEdge>[]> | Promise<Nullable<Nullable<EventOffering_PassEdge>[]>>;
    eventOfferingClusters(location: GeolocationInput, tierGroupScope?: Nullable<boolean>, startDate?: Nullable<string>, endDate?: Nullable<string>, sortBy?: Nullable<string>, knownTileKeys?: Nullable<Nullable<string>[]>): Nullable<Nullable<EventLocationCluster>[]> | Promise<Nullable<Nullable<EventLocationCluster>[]>>;
    facilityOfferings(location: GeolocationInput, tierGroupScope?: Nullable<boolean>, limit?: Nullable<number>, offset?: Nullable<number>, sortBy?: Nullable<string>, knownTileKeys?: Nullable<Nullable<string>[]>): Nullable<Nullable<FacilityOffering>[]> | Promise<Nullable<Nullable<FacilityOffering>[]>>;
    facilityOfferingsRenewActive(location: GeolocationInput, tierGroupScope?: Nullable<boolean>, limit?: Nullable<number>, offset?: Nullable<number>, sortBy?: Nullable<string>, knownTileKeys?: Nullable<Nullable<string>[]>): Nullable<Nullable<FacilityOffering>[]> | Promise<Nullable<Nullable<FacilityOffering>[]>>;
    adminRenewActiveGymSearch(memberCode: string, location: GeolocationInput, limit?: Nullable<number>, offset?: Nullable<number>, sortBy?: Nullable<string>): AdminRenewActiveGymSearchResult | Promise<AdminRenewActiveGymSearchResult>;
    facilityOfferingsMobile(location: GeolocationInput, tierGroupScope?: Nullable<boolean>, limit?: Nullable<number>, offset?: Nullable<number>, name?: Nullable<string>, tags?: Nullable<string>, sortBy?: Nullable<string>, knownTileKeys?: Nullable<Nullable<string>[]>): Nullable<Nullable<FacilityOffering>[]> | Promise<Nullable<Nullable<FacilityOffering>[]>>;
    facilityOfferingsMobileRenewActive(location: GeolocationInput, tierGroupScope?: Nullable<boolean>, limit?: Nullable<number>, offset?: Nullable<number>, name?: Nullable<string>, tags?: Nullable<string>, sortBy?: Nullable<string>, knownTileKeys?: Nullable<Nullable<string>[]>): Nullable<Nullable<FacilityOffering>[]> | Promise<Nullable<Nullable<FacilityOffering>[]>>;
    locationBasedFacilityOfferingsRenewActive(location: GeolocationInput, name?: Nullable<string>, serviceSector?: Nullable<string>, sponsorId?: Nullable<string>, product?: Nullable<string>, isForDependentMember?: Nullable<boolean>, sector?: Nullable<string>, authTagKeys?: Nullable<Nullable<string>[]>, limit?: Nullable<number>, offset?: Nullable<number>, sortBy?: Nullable<string>, isAdminPortal?: Nullable<boolean>, isClientNonMarketed?: Nullable<boolean>, network?: Nullable<string>): Nullable<Nullable<FacilityOffering>[]> | Promise<Nullable<Nullable<FacilityOffering>[]>>;
    locationBasedFacilityOfferings(location: GeolocationInput, name?: Nullable<string>, serviceSector?: Nullable<string>, sponsorId?: Nullable<string>, product?: Nullable<string>, isForDependentMember?: Nullable<boolean>, sector?: Nullable<string>, authTagKeys?: Nullable<Nullable<string>[]>, limit?: Nullable<number>, offset?: Nullable<number>, sortBy?: Nullable<string>, isAdminPortal?: Nullable<boolean>, isClientNonMarketed?: Nullable<boolean>, network?: Nullable<string>): Nullable<Nullable<FacilityOffering>[]> | Promise<Nullable<Nullable<FacilityOffering>[]>>;
    staticOfferings(featureKey?: Nullable<string>, featureKeys?: Nullable<Nullable<string>[]>, tierGroupScope?: Nullable<boolean>): Nullable<Nullable<StaticOffering_PassEdge>[]> | Promise<Nullable<Nullable<StaticOffering_PassEdge>[]>>;
    onlineFitnessOfferings(): Nullable<Nullable<OnlineFitnessOffering>[]> | Promise<Nullable<Nullable<OnlineFitnessOffering>[]>>;
    vodVideos(category?: Nullable<string>, level?: Nullable<string>, language?: Nullable<string>, limit?: Nullable<number>, cursor?: Nullable<string>): VodVideoList | Promise<VodVideoList>;
    vodVideo(videoId: string): Nullable<VodVideo> | Promise<Nullable<VodVideo>>;
    vodCategories(): VodCategory[] | Promise<VodCategory[]>;
    vodSearch(q: string, limit?: Nullable<number>, cursor?: Nullable<string>): VodVideoList | Promise<VodVideoList>;
    vodFavorites(): VodFavorite[] | Promise<VodFavorite[]>;
    advantageChromeInfo(): Nullable<AdvantageChrome> | Promise<Nullable<AdvantageChrome>>;
    locationSuggestions(query: string, biasLatitude?: Nullable<number>, biasLongitude?: Nullable<number>, isSearchByZipCodeOnly?: Nullable<boolean>): Nullable<Nullable<Geolocation>[]> | Promise<Nullable<Nullable<Geolocation>[]>>;
    checkMemberAccessToGym(facilityId?: Nullable<string>, memberTags?: Nullable<Nullable<string>[]>, product?: Nullable<string>, serviceSector?: Nullable<string>, sponsorId?: Nullable<string>, isDependent?: Nullable<boolean>): boolean | Promise<boolean>;
    memberCheckForCode(code?: Nullable<string>): MemberCheck | Promise<MemberCheck>;
    memberCheckForCodeV2(code?: Nullable<string>): MemberCheck | Promise<MemberCheck>;
    memberCheckForBigN(bigN?: Nullable<MemberBigNInput>): MemberCheck | Promise<MemberCheck>;
    memberEligibilityCheckForBigNForStandalone(bigN?: Nullable<MemberBigNInput>, serviceSector?: Nullable<string>, email?: Nullable<string>, marketingConsent?: Nullable<boolean>): MemberEligibilityCheck | Promise<MemberEligibilityCheck>;
    memberEligibilityCheckForHSID(hsidEligibilityCheckRequest?: Nullable<HsidEligibilityCheckRequest>): HsidEligibilityCheckResponse | Promise<HsidEligibilityCheckResponse>;
    getUserAcceptanceValue(): Nullable<UserAcceptance> | Promise<Nullable<UserAcceptance>>;
    previewSubscription(previewInput?: Nullable<PreviewInput>): Nullable<PreviewInfo> | Promise<Nullable<PreviewInfo>>;
    previewSubscriptionForDependent(previewInput?: Nullable<PreviewInput>): Nullable<PreviewInfo> | Promise<Nullable<PreviewInfo>>;
    rewardsDollarAmount(): RewardsDollarAmount | Promise<RewardsDollarAmount>;
    hsidSession(): Nullable<HsidSession> | Promise<Nullable<HsidSession>>;
    ohidSession(): Nullable<OhidSession> | Promise<Nullable<OhidSession>>;
    promoCodes(): Nullable<Nullable<PromoCode>[]> | Promise<Nullable<Nullable<PromoCode>[]>>;
    codesRedeemedOnAnAccount(): Nullable<string> | Promise<Nullable<string>>;
    availableOnePassCredit(): Nullable<AvailableOnePassCredit> | Promise<Nullable<AvailableOnePassCredit>>;
    reportToken(clientName: string): Nullable<TrustedToken> | Promise<Nullable<TrustedToken>>;
    getUnverifiedMemberStepUpUrl(searchId: string): string | Promise<string>;
}

export interface IMutation {
    picksTier(tierId: string, tierName: string): Nullable<boolean> | Promise<Nullable<boolean>>;
    saveVodFavorite(favoriteType: VodFavoriteType, targetId: string): VodFavorite | Promise<VodFavorite>;
    deleteVodFavorite(favoriteType: VodFavoriteType, targetId: string): VodFavoriteMutationResult | Promise<VodFavoriteMutationResult>;
    logout(): Nullable<boolean> | Promise<Nullable<boolean>>;
    clientLogout(): Nullable<boolean> | Promise<Nullable<boolean>>;
    enrollTierWithPayment(tierId: string, recurlyToken: string, email: string, rewardsDollarsApplied?: Nullable<number>, promoCodeConfiguration?: Nullable<PromoCodeConfiguration>, paymentType?: Nullable<PaymentType>): Nullable<boolean> | Promise<Nullable<boolean>>;
    sendPrimaryEnrollEmail(tierId: string, email: string, isPromotionalCommunicationsAccepted?: Nullable<boolean>): Nullable<string> | Promise<Nullable<string>>;
    updateSponsorSearchMarketingPreference(sponsorName: string, sponsorId: string, eligibilityStatus: string, email?: Nullable<string>, optIn?: Nullable<boolean>): Nullable<string> | Promise<Nullable<string>>;
    enrollTierNoPayment(tierId: string, isTierDiscountPromoValid?: Nullable<boolean>, promoCode?: Nullable<string>): Nullable<boolean> | Promise<Nullable<boolean>>;
    requestChangeTierNoPayment(tierId: string, isTierDiscountPromoValid?: Nullable<boolean>, promoCode?: Nullable<string>): Nullable<boolean> | Promise<Nullable<boolean>>;
    requestChangeCancelPendingTier(tierId: string): Nullable<boolean> | Promise<Nullable<boolean>>;
    requestChangeCancelDependentPendingTier(dependentId: string, tierId: string): Nullable<boolean> | Promise<Nullable<boolean>>;
    requestChangeTierWithPayment(tierId: string, recurlyToken: string, email: string): Nullable<boolean> | Promise<Nullable<boolean>>;
    updateMemberLastLocation(summary?: Nullable<string>, latitude?: Nullable<number>, longitude?: Nullable<number>): Nullable<MemberLocation> | Promise<Nullable<MemberLocation>>;
    updateMemberFTUEViewed(): Nullable<string> | Promise<Nullable<string>>;
    deleteMemberFTUEViewed(dependentId?: Nullable<string>): Nullable<boolean> | Promise<Nullable<boolean>>;
    updateUserAcceptanceValue(authKey: string): Nullable<boolean> | Promise<Nullable<boolean>>;
    revokeUserAcceptanceValue(authKey: string): Nullable<boolean> | Promise<Nullable<boolean>>;
    sendSurveyAnswers(questionId: string, response: string, memberId: string): Nullable<string> | Promise<Nullable<string>>;
    updateHipaaConsent(): Nullable<boolean> | Promise<Nullable<boolean>>;
    deleteHipaaConsent(): Nullable<boolean> | Promise<Nullable<boolean>>;
    submitSFCase(sfcaseRequest?: Nullable<SFCaseRequest>): Nullable<EmailSupportResponse> | Promise<Nullable<EmailSupportResponse>>;
    redeemRewards(dollars: number): Nullable<DebitRewards> | Promise<Nullable<DebitRewards>>;
    addDependent(dependentBigNInput?: Nullable<DependentBigNInput>): Nullable<DependentEdgeResponse> | Promise<Nullable<DependentEdgeResponse>>;
    addDependentGovernment(dependentBigNInput?: Nullable<DependentBigNInput>): Nullable<DependentEdgeResponse> | Promise<Nullable<DependentEdgeResponse>>;
    updateDependent(dependentId: string, dependentBigNInput?: Nullable<DependentBigNInput>): Nullable<DependentEdgeResponse> | Promise<Nullable<DependentEdgeResponse>>;
    updateDependentGovernment(dependentId: string, dependentBigNInput?: Nullable<DependentBigNInput>): Nullable<DependentEdgeResponse> | Promise<Nullable<DependentEdgeResponse>>;
    enrollDependentTierWithPayment(tierId: string, recurlyToken: string, dependentId: string, email: string): Nullable<DependentEdgeResponse> | Promise<Nullable<DependentEdgeResponse>>;
    updateDependentTier(dependentId: string, tierId?: Nullable<string>): Nullable<DependentEdgeResponse> | Promise<Nullable<DependentEdgeResponse>>;
    qualifiedMemberCheckForCode(code: string): Member_Pass | Promise<Member_Pass>;
    cancelDependent(dependentId: string, tierId: string): Nullable<DependentEdgeResponse> | Promise<Nullable<DependentEdgeResponse>>;
    deleteDependent(dependentId: string): Nullable<DependentEdgeResponse> | Promise<Nullable<DependentEdgeResponse>>;
    restartMembershipDependent(dependentId: string, tierId: string): Nullable<DependentEdgeResponse> | Promise<Nullable<DependentEdgeResponse>>;
    deactivateDependent(dependentId: string): Nullable<DependentEdgeResponse> | Promise<Nullable<DependentEdgeResponse>>;
    reactivateDependent(dependentId: string): Nullable<DependentEdgeResponse> | Promise<Nullable<DependentEdgeResponse>>;
    updateExcludedFacilities(sector: ServiceSectorKey, action: ExclusionAction, facilities: FacilityKeyInput[]): boolean | Promise<boolean>;
    clearCache(cacheKey: string): Nullable<boolean> | Promise<Nullable<boolean>>;
    selectTierGroup(tierGroupId: string): Nullable<TierGroup> | Promise<Nullable<TierGroup>>;
    updatePayment(recurlyToken: string): Nullable<RecurlyResponse> | Promise<Nullable<RecurlyResponse>>;
    cancelMembership(surveyAnswers?: Nullable<Nullable<SurveyAnswer>[]>): Nullable<Member_Pass> | Promise<Nullable<Member_Pass>>;
    cancelMembershipCancellationAPI(reasonsWithDetails?: Nullable<Nullable<CancellationReasonWithDetail>[]>): Nullable<Member_Pass> | Promise<Nullable<Member_Pass>>;
    ensureAllCancellationReasons(): Nullable<Nullable<CancellationReason>[]> | Promise<Nullable<Nullable<CancellationReason>[]>>;
    ensureAllSurveys(): Nullable<Nullable<Survey>[]> | Promise<Nullable<Nullable<Survey>[]>>;
    ensureAllSurveyQuestions(): Nullable<Nullable<SurveyQuestion>[]> | Promise<Nullable<Nullable<SurveyQuestion>[]>>;
    ensureAllSurveyQuestionOptions(): Nullable<Nullable<SurveyQuestionOption>[]> | Promise<Nullable<Nullable<SurveyQuestionOption>[]>>;
    ensureAllSponsors(): Nullable<Nullable<Sponsor>[]> | Promise<Nullable<Nullable<Sponsor>[]>>;
    ensureAllTierGroups(): Nullable<Nullable<TierGroup>[]> | Promise<Nullable<Nullable<TierGroup>[]>>;
    resetSponsorCache(): Nullable<boolean> | Promise<Nullable<boolean>>;
    resetTierCache(): Nullable<boolean> | Promise<Nullable<boolean>>;
    resetTierGroupCache(): Nullable<boolean> | Promise<Nullable<boolean>>;
    removeUninvoicedLineItem(dependentId?: Nullable<string>): Nullable<Empty> | Promise<Nullable<Empty>>;
    markInvoiceAsFailedForMember(dependentId?: Nullable<string>): Nullable<RecurlyResponse> | Promise<Nullable<RecurlyResponse>>;
    sendMemberDataEvent(memberDataEvent?: Nullable<MemberDataEventInput>): Nullable<Empty> | Promise<Nullable<Empty>>;
}

export type DateTime = any;
export type JsonObject = any;
type Nullable<T> = T | null;
